<template>
    <div style="margin-top: 24px;">
        <div style="">
            <template>
                <!-- <div style="font-size: 32px; font-weight: 700; line-height: 46px; text-align: center;">활동지역을 알려주세요</div> -->
                <div style="position: relative; text-align: center; margin-top: 16px; margin-bottom: 12px;">
                    <img style="width: 20px; position: absolute; top: 50%; margin-left: 12px; transform: translateY(-50%);" :src="require('@/assets/img/search_new_gray.png')" alt="">
                    <input :class="'common_input_no_search'" class="common_input" style="padding-left: 40px;" ref="searchWordInput" placeholder="지역을 검색하세요" type="text" v-model="searchWord" enterkeyhint="done" @keyup="enter($event)">
                </div>
            </template>
        </div>
        <div @touchstart="touchStart" style="border-radius: 12px; width: 310px; margin: 0 auto; flex: 1; overflow-y: scroll; padding-bottom: 20px;" v-if="isSearch">
            <InfinityScroll style="border-radius: 12px;" >
                <div :style="{ paddingTop: i === 0 ? '8px' : '5px' }" v-for="each, i in regions" :key="i" style="display:flex; align-items: center; padding: 6px 8px; background-color: #fff;" @click="select(each)">
                    <div style="flex:1; font-weight: 500; line-height: 24px;" v-html="each.display_str"></div>
                </div>
            </InfinityScroll>
        </div>
        <template v-if="selectedData && selectedData.id">
            <div style="display:flex; align-items:center; height: 48px; border-radius: 30px; background-color: var(--color-main); justify-content: center; padding: 0 20px; margin: 0 auto; margin-top: 16px; min-width: 172px; max-width: 210px; border: 1px solid #d9d9d9;">
                <div style="font-size: 16px; font-weight: 500; line-height: 24px;">{{ selectedData.name }}</div>
            </div>
        </template>
    </div>
</template>

<script>
import InfinityScroll from "./InfinityScroll";
import _ from 'lodash';
import ResponseCode from "../../ResponseCode";
export default {
    name: "RegionSearchSelectorVer2",
    components: { InfinityScroll },
    props: {
        detectSelect: {
            type: Function,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            regions: [],
            searchWord: '',
            selectedData: {
                // code : '1234',
                // sido : '부산광역시',
                // sigungu : '연제구'
            },
            isSearch: false,
        }
    },
    computed: {
        calcHeight() {
            if (this.regions.length === 0) {
                return '100%'
            } else {
                return '250px'
            }
        }
    },
    methods: {
        touchStart() {
            setTimeout(() => {
                this.$refs.searchWordInput.blur()
            }, 100)
        },
        enter(e) {
            this.searchBefore();
            if(e.keyCode === 13){
                setTimeout(() => {
                    document.activeElement.blur();
                }, 50)
            }
        },
        throttleKeyup: () => { },
        searchBefore() {
            if (this.$refs.searchWordInput.value !== '') {
                this.page = 1;
                this.regions = [];
                this.throttleKeyup();
            } else {
                this.unselect();
            }
        },
        async search() {
            const searchWord = this.$refs.searchWordInput.value;
            const parameters = {};
            parameters.searchWord = searchWord
            const res = await this.$Axios.get('/api/place', { params: parameters });

            if(res.data.code === ResponseCode.SUCCESS){
                const places = res.data.places;

                for (const each of places) {
                    each.display_str = (each.name).replace(searchWord, "<span style='color:var(--color-main)'>" + searchWord + "</span>")
                }

                if (places.length > 0) {
                    this.isSearch = true
                    this.regions = places;
                }
            }

        },
        select(data) {
            this.regions = [];
            this.searchWord = ''
            this.isSearch = false;
            this.selectedData = data;
            this.detectSelect(data);
        },
        unselect() {
            if (this.searchWord !== '') {
                this.selectedData = {};
            }
            this.isSearch = false;
            this.searchWord = '';
            // this.detectSelect(null);
            // this.$nextTick(() => {
            //     this.$refs.searchWordInput.focus();
            // })

        }
    },
    created() {
        this.throttleKeyup = _.debounce(() => {
            this.search();
        }, 500);
        if (this.mode === 'update') {
            this.select(this.registInfo.region)
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border: none;
    padding: 0 12px;
}

.common_input_no_search {
    border-radius: 12px;
}

.common_input_search {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>